/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Caption_Style_Roll_Up_4Inputs */



/**
* | output |
* | --- |
* | "Roll-Up 4" |
*
* @param {Input_Caption_Style_Roll_Up_4Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_caption_style_roll_up_4 = /** @type {((inputs?: Input_Caption_Style_Roll_Up_4Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Caption_Style_Roll_Up_4Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Déroulant 4")
	if (locale === "de") return /** @type {LocalizedString} */ ("Roll-Up 4")
	if (locale === "it") return /** @type {LocalizedString} */ ("Roll-Up 4")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Roll-Up 4")
	if (locale === "es") return /** @type {LocalizedString} */ ("Rollo 4")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Roll-Up 4")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ロールアップ4")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रोल-अप 4")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Enrole 4")
	return /** @type {LocalizedString} */ ("Roll-Up 4")
});